export const MOUSE_SUBDOMAIN = 'climbmouse';
export const SPACE_SUBDOMAIN = 'myspace';
export const ZACHIPKA_SUBDOMAIN = 'zachipka';
export const SUBDOMAINS_WITH_EN_FORM = [SPACE_SUBDOMAIN];
